module.exports = __webpack_public_path__ + "img/loading.b6d49d6b.svg";